import React, { Component } from "react";
import { Link } from "react-router-dom";
import InputRange from "react-input-range";
import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { PiInfo } from "react-icons/pi";

import "./launch-modal.css";
import "react-input-range/lib/css/index.css";

export default class ConfiguredModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLectureSwitching: false,
			isCheckConfigure: false,
			isVideoSeeking: false,
			isSkipQuestions: false,
			isQuizBeforeVideo: false,
			isQuizFailReminder: false,
			isQuizRandomizer: false,
			isUserCorrectAnswer: false,
			isVideoSpeedControls: false,
			isLectureSwitchRestriction: false,
			quizPassingPercentage: 0,
			gamePassingPercentage: 0,
		};
	}

	componentDidUpdate = (prevProps) => {
		if (this.props.options !== prevProps.options) {
			this.setState({
				isLectureSwitching: this.props.options.isLectureSwitching,
				isVideoSeeking: this.props.options.isVideoSeeking,
				isSkipQuestions: this.props.options.isSkipQuestions ?? false,
				isQuizBeforeVideo: this.props.options.isQuizBeforeVideo,
				isQuizFailReminder: this.props.options.isQuizFailReminder,
				isQuizRandomizer: this.props.options.isQuizRandomizer ?? false,
				isUserCorrectAnswer: this.props.options.isUserCorrectAnswer,
				isVideoSpeedControls: this.props.options.isVideoSpeedControls,
				isLectureSwitchRestriction: this.props.options.isLectureSwitchRestriction ?? false,
				quizPassingPercentage: this.props.options.quizPassingPercentage,
				gamePassingPercentage: this.props.options.gamePassingPercentage ?? 0,
			});
		}
	};

	clickHandle = () => {
		let options = {
			isCheckConfigure: true,
			isVideoSeeking: this.state.isVideoSeeking,
			isSkipQuestions: this.state.isSkipQuestions,
			isQuizBeforeVideo: this.state.isQuizBeforeVideo,
			isLectureSwitching: this.state.isLectureSwitching,
			isQuizFailReminder: this.state.isQuizFailReminder,
			isQuizRandomizer: this.state.isQuizRandomizer,
			isUserCorrectAnswer: this.state.isUserCorrectAnswer,
			isVideoSpeedControls: this.state.isVideoSpeedControls,
			isLectureSwitchRestriction: this.state.isLectureSwitchRestriction,
			quizPassingPercentage: this.state.quizPassingPercentage,
			gamePassingPercentage: this.state.gamePassingPercentage,
		};
		this.props.setOptions(this.props.courseId, options);
		this.props.showHandle();
	};

	handleLectureSwitching = (e) => {
		this.setState({ isLectureSwitching: e.target.checked });
	};
	handleVideoSeeking = (e) => {
		this.setState({ isVideoSeeking: e.target.checked });
	};
	handleSkipQuestions = (e) => {
		this.setState({ isSkipQuestions: e.target.checked });
	};
	handleQuizRandomizer = (e) => {
		this.setState({ isQuizRandomizer: e.target.checked });
	};
	handleLectureSwitchRestriction = (e) => {
		this.setState({ isLectureSwitchRestriction: e.target.checked });
	};
	handleVideoSpeedControlsChange = (e) => {
		this.setState({ isVideoSpeedControls: e.target.checked });
	};
	handleQuizBeforeVideo = (e) => {
		this.setState({ isQuizBeforeVideo: e.target.checked });
	};
	handleQuizFailReminder = (e) => {
		this.setState({ isQuizFailReminder: e.target.checked });
	};
	handleUserCorrectAnswer = (e) => {
		this.setState({ isUserCorrectAnswer: e.target.checked });
	};
	handleVideoSpeedControls = (e) => {
		this.setState({ isVideoSpeedControls: e.target.checked });
	};

	renderTooltip = (text) => (
		<OverlayTrigger placement="top" overlay={<Tooltip>{text}</Tooltip>}>
			<span className="setting-tooltip-icon">
				<PiInfo />
			</span>
		</OverlayTrigger>
	);

	render() {
		return (
			<Modal
				show={this.props.showModal}
				className="chooseModal"
				onHide={() => this.props.showHandle()}
				dialogClassName="modal-90w"
				aria-labelledby="example-custom-modal-styling-title"
			>
				<Modal.Header closeButton>
					<div id="example-custom-modal-styling-title">
						<h5>Course Settings</h5>
						<p>Configure course settings according to your preference</p>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group" id="course-setting-wrapper" style={{ marginBottom: "0px" }}>
						<div className="cst-wrapper">
							<div className="row settings-Vsec">

								<div className="settingBox">
									<div className="d-flex align-items-center justify-content-between">
										<h5>
											Lecture Switching
											{this.renderTooltip("Enable this feature to allow the learners to skip the lecture and jump to the next lecture.")}
										</h5>
										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												name="setting1"
												id="setting1"
												autoComplete="off"
												value={true}
												checked={this.state.isLectureSwitching}
												onChange={this.handleLectureSwitching}
											/>
											<label className="custom-control-label" htmlFor="setting1"></label>
										</div>
									</div>
								</div>

								<div className="settingBox">
									<div className="d-flex align-items-center justify-content-between">
										<h5>
											Video Seeking
											{this.renderTooltip(" This feature enables the learner to forward the time frame of the lecture video.")}
										</h5>
										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												name="setting2"
												id="setting2"
												autoComplete="off"
												value={true}
												checked={this.state.isVideoSeeking}
												onChange={this.handleVideoSeeking}
											/>
											<label className="custom-control-label" htmlFor="setting2"></label>{" "}
										</div>
									</div>
								</div>

								<div className="settingBox">
									<div className="d-flex align-items-center justify-content-between">
										<h5>
											Allow Skip Questions
											{this.renderTooltip(" Enable this option to allow learners to skip quiz questions.")}
										</h5>

										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												name="settingSkipQuestions"
												id="settingSkipQuestions"
												autoComplete="off"
												value={true}
												checked={this.state.isSkipQuestions}
												onChange={this.handleSkipQuestions}
											/>
											<label className="custom-control-label" htmlFor="settingSkipQuestions"></label>
										</div>
									</div>
								</div>

								<div className="settingBox">
									<div className="d-flex align-items-center justify-content-between">
										<h5>
											Allow Quiz Before Video
											{this.renderTooltip(" Enable this feature to allow your learners to attempt the quiz before watching lecture videos.")}
										</h5>

										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												name="setting3"
												id="setting3"
												autoComplete="off"
												value={true}
												checked={this.state.isQuizBeforeVideo}
												onChange={this.handleQuizBeforeVideo}
											/>
											<label className="custom-control-label" htmlFor="setting3"></label>
										</div>
									</div>
								</div>

								<div className="settingBox">
									<div className="d-flex align-items-center justify-content-between">
										<h5>
											Allow Quiz Failed Reminder
											{this.renderTooltip(" Enable this option to send the reminder email to the learners who have failed the quiz.")}
										</h5>

										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												name="setting4"
												id="setting4"
												autoComplete="off"
												value={true}
												checked={this.state.isQuizFailReminder}
												onChange={this.handleQuizFailReminder}
											/>
											<label className="custom-control-label" htmlFor="setting4"></label>
										</div>
									</div>

								</div>

								<div className="settingBox">
									<div className="d-flex align-items-center justify-content-between">
										<h5>
											Allow Quiz Randomizer
											{this.renderTooltip("Enable this option to create random order of quiz on the learner side.")}
										</h5>

										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												name="settingQuizRandomizer"
												id="settingQuizRandomizer"
												autoComplete="off"
												value={true}
												checked={this.state.isQuizRandomizer}
												onChange={this.handleQuizRandomizer}
											/>
											<label className="custom-control-label" htmlFor="settingQuizRandomizer"></label>
										</div>
									</div>

								</div>

								<div className="settingBox">
									<div className="d-flex align-items-center justify-content-between">
										<h5>
											Allow Correct Answer Enforcement
											{this.renderTooltip(" Enable this option to let user select only correct answer.")}
										</h5>

										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												name="setting5"
												id="setting5"
												autoComplete="off"
												value={true}
												checked={this.state.isUserCorrectAnswer}
												onChange={this.handleUserCorrectAnswer}
											/>
											<label className="custom-control-label" htmlFor="setting5"></label>
										</div>
									</div>
								</div>

								<div className="settingBox">
									<div className="d-flex align-items-center justify-content-between">
										<h5>
											Video Speed Controls
											{this.renderTooltip("  Enable this option to give Learners controls to fast-forward the video.")}
										</h5>
										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												name="setting6"
												id="setting6"
												autoComplete="off"
												value={true}
												checked={this.state.isVideoSpeedControls}
												onChange={this.handleVideoSpeedControls}
											/>
											<label className="custom-control-label" htmlFor="setting6"></label>
										</div>
									</div>
								</div>

								<div className="settingBox">
									<div className="d-flex align-items-center justify-content-between">
										<h5>
											Lecture Switch Restriction Until Quiz Is Passed
											{this.renderTooltip("The learner must pass the quiz before being allowed to switch lectures.")}
										</h5>
										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												name="settingLectureSwitchRestriction"
												id="settingLectureSwitchRestriction"
												autoComplete="off"
												value={true}
												checked={this.state.isLectureSwitchRestriction}
												onChange={this.handleLectureSwitchRestriction}
											/>
											<label className="custom-control-label" htmlFor="settingLectureSwitchRestriction"></label>
										</div>
									</div>
								</div>

								<div className="settingBox settingBox-slider">
									<div className="d-flex align-items-start justify-content-between">
										<h5>
											Quiz Passing (%)
											{this.renderTooltip(" Set a passing % for Quiz")}
										</h5>
										<div className="custom-control custom-switch" style={{ width: "60%" }}>
											<InputRange
												maxValue={100}
												minValue={0}
												value={this.state.quizPassingPercentage}
												onChange={(value) => this.setState({ quizPassingPercentage: value })}
											/>

										</div>
									</div>
								</div>

								<div className="settingBox settingBox-slider">
									<div className="d-flex align-items-start justify-content-between">
										<h5>
											Game Passing (%)
											{this.renderTooltip(" Set a passing % for Game")}
										</h5>
										<div className="custom-control custom-switch" style={{ width: "60%" }}>
											<InputRange
												maxValue={100}
												minValue={0}
												value={this.state.gamePassingPercentage}
												onChange={(value) => this.setState({ gamePassingPercentage: value })}
											/>

										</div>
									</div>
								</div>

							</div>

							{/* <div className="row settings-Vsec hide-quiz mb-0">
								<div className="col-lg-5">
									<div className="page-separator">
										<div className="page-separator__text">Quiz Passing (%)</div>
									</div>
								</div>
								<div className="col-lg-6">
									<InputRange
										maxValue={100}
										minValue={0}
										value={this.state.quizPassingPercentage}
										onChange={(value) => this.setState({ quizPassingPercentage: value })}
									/>
								</div>
							</div> */}
						</div>
					</div>

				</Modal.Body>
				<div className="modal-footer">
					<div className="text-right">
						<Link to="#" onClick={this.handleNextPath}>
							<Button className="btn closeBtn mr-2" onClick={() => this.props.showHandle()}>
								{" "}
								Close{" "}
							</Button>
							<Button className='btn btn-success' onClick={() => this.clickHandle()}>
								{" "}
								Save Settings{" "}
							</Button>
						</Link>
					</div>
				</div>
			</Modal>
		);
	}
}
